import React from "react";

const Applications = () => {
  return (
    <>
      {/* =============== About Area Five End ===============*/}
      <div className='about-area pd-top-120 pd-bottom-120'>
        <div className='container'>
          <div className='row'>
            <div
              className='col-lg-6 mb-4 mb-lg-0'
              data-aos='fade-right'
              data-aos-delay='200'
              data-aos-duration='1500'
            >
              <div className='about-thumb-inner'>
                <img
                  className='main-img'
                  src='assets/img/about/app1.png'
                  alt='img'
                />
                <h5 className="mt-3 text-center">Fertilizer Industry</h5>
              </div>
            </div>
            <div
              className='col-lg-6'
              data-aos='fade-left'
              data-aos-delay='200'
              data-aos-duration='1500'
            >
            <div className='about-thumb-inner'>
              <img
                className='main-img'
                src='assets/img/about/app2.png'
                alt='img'
              />
              <h5 className="mt-3 text-center">Boiler, Heat Exchanger, Condenser, Pulverizer</h5>
            </div>
            </div>
          </div>
          <div className='row mt-3'>
            <div
              className='col-lg-6 mb-4 mb-lg-0'
              data-aos='fade-right'
              data-aos-delay='200'
              data-aos-duration='1500'
            >
              <div className='about-thumb-inner'>
                <img
                  className='main-img'
                  src='assets/img/about/app3.png'
                  alt='img'
                />
                <h5 className="mt-3 text-center">Steel Plants</h5>
              </div>
            </div>
            <div
              className='col-lg-6'
              data-aos='fade-left'
              data-aos-delay='200'
              data-aos-duration='1500'
            >
            <div className='about-thumb-inner'>
              <img
                className='main-img'
                src='assets/img/about/app4.png'
                alt='img'
              />
              <h5 className="mt-3 text-center">Fabrication</h5>
            </div>
            </div>
          </div>
          <div className='row mt-3'>
            <div
              className='col-lg-6'
              data-aos='fade-left'
              data-aos-delay='200'
              data-aos-duration='1500'
            >
            <div className='about-thumb-inner'>
              <img
                className='main-img'
                src='assets/img/about/app6.png'
                alt='img'
              />
              <h5 className="mt-3 text-center">Water Treatment Plant</h5>
            </div>
            </div>
          </div>
        </div>
      </div>

      {/* =============== About Area Five End ===============*/}
    </>
  );
};

export default Applications;
